module.exports = __webpack_public_path__ + "img/ChiliBags-250.219794da.jpg";